module.exports = __webpack_public_path__ + "img/my.07fd2be8.svg";